import { combineReducers } from '@reduxjs/toolkit'
import session from './sessionSlice'
import user from './userSlice'
import feature from './featureSlice'

const reducer = combineReducers({
    session,
    user,
    feature,
})

export default reducer
